import { Box, Table, TableBody, TableContainer } from "@mui/material";
import { useContext, useState } from "react";
import { CancelledEmployment } from "../../../talents/talentAPI";
import BundleHeader from "../Shared/BundleHeader/BundleHeader";
import EmploymentRow from "../Shared/EmploymentRow";
import { EmploymentRowType } from "../types";
import { AccessRightContext } from "../../../user/AccessRightProvider";
import { useAppSelector } from "../../../../app/hooks";

interface Props {
  sectionName: string;
  cancelledEmployments: CancelledEmployment[];
}

export const CancelledEmploymentsSection = ({
  sectionName,
  cancelledEmployments,
}: Props) => {
  const [open, setOpen] = useState<boolean>(false);

  const { canReadEmployment } = useContext(AccessRightContext);
  const translatedTes = useAppSelector((state) => state.localized.tes);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        background: "#FFFFFF",
        alignItem: "center",
      }}
    >
      <BundleHeader open={open} setOpen={setOpen} title={sectionName} />
      {open && (
        <Box sx={{ paddingBottom: "8px" }}>
          <TableContainer>
            <Table>
              <TableBody>
                {cancelledEmployments.map((employment, index) => (
                  <EmploymentRow
                    key={`cancelled-employment-${employment.employmentId}-${index}`}
                    disabled={!canReadEmployment(employment.employerId)}
                    employment={employment}
                    index={index}
                    type={EmploymentRowType.Cancelled}
                    tesName={translatedTes[employment.tesId]}
                    employerName={employment.employerName}
                    isShift={employment.isShift}
                    continuousEmploymentId={undefined}
                  />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      )}
    </Box>
  );
};
